var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.833C6.634 26.833.665 20.864.665 13.5S6.636.167 13.999.167c7.364 0 13.334 5.969 13.334 13.333s-5.97 13.333-13.334 13.333zm0-2.666a10.667 10.667 0 100-21.334 10.667 10.667 0 000 21.334zm-1.334-5.334h-4V8.167h4V5.5h2.667v2.667h1.333a3.333 3.333 0 012.667 5.333 3.333 3.333 0 01-2.667 5.333h-1.333V21.5h-2.667v-2.667zm-1.333-4v1.334h5.333a.667.667 0 100-1.334h-5.333zm0-4v1.334h5.333a.667.667 0 100-1.334h-5.333z",
    fill: "#F8FAFF"
  })));
}
export default SvgCryptoWhite;